define('bizzabo/models/community/PersonSearch',['backbone-easyxdm','bizzabo/models/community/PersonCollection'], function (Backbone, PersonCollection) {

    var PersonSearch = Backbone.Model.extend({

        req_version: 1,

        initialize: function() {
            this.unfinishedRequestCount = 0;
            this.listenTo(this, 'request', this.modelRequested);
            this.listenTo(this, 'sync', this.modelSynced);
            this.listenTo(Backbone, 'scrolled-to-bottom', this.fetchNextPage);
        },

        modelRequested: function() {
            this.unfinishedRequestCount++;
        },

        modelSynced: function() {
            this.unfinishedRequestCount--;
        },

        url: function() {
            var base = '/api/v1/organizer/event/' + this.query.id + '/person?';
            var addParam = function(base, query, name) {
                if (query.has(name)) {
                    base += name + '=' + encodeURIComponent(query.get(name)) + '&';
                }
                return base;
            };
            base = addParam(base, this.query, 'q');
            base = addParam(base, this.query, 'sort');
            base = addParam(base, this.query, 'sort-order');
            base = addParam(base, this.query, 'count');
            base = addParam(base, this.query, 'offset');

            return base;
        },

        parse: function(response,options) {
            if (options.req_version < this.req_version){
                return null;
            }

            response.person = response.person || [];
            response.facets = response.facets || {};

            return response;
        },

        setQuery: function(query) {
            this.query = query;

            var fetchWithoutParams = function() {
                this.query.set('offset', 0, {
                    silent: true
                });
                this.fetch({req_version: ++this.req_version});
            };
            this.listenTo(this.query, 'change:q change:sort change:sort-order search', fetchWithoutParams);

            var offsetChanged = function() {
                var total = this.get('total') || 0;
                var offset = this.query.get('offset') || 0;
                var shouldFetch = (offset <= total);
                shouldFetch && this.fetch();
            };
            this.listenTo(this.query, 'change:offset', offsetChanged);
        },

        fetchNextPage: function() {
            if (this.unfinishedRequestCount > 0) {
                return;
            }
            var total = this.get('total') || 0;
            var offset = this.query.get('offset') || 0;
            var count = this.query.get('count');
            if (offset + count < total) {
                var newOffset = offset + count;
                this.query.set('offset', newOffset);
            }
        }

    });

    return PersonSearch;
});
